import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import {
  BiContextProvidedValue,
  BiData,
  DefaultBiEvent,
} from '@wix/da-bi/pkg/events';
import Eyecon from '@wix/da-ds/pkg/Icons/Eye';
import useDeviationStats from './useDeviationStats';
import Stat from './Stat';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
  /** don't display language after stat count */
  onlyNumbers?: boolean;
}

const ViewStat: React.FC<Props> = ({ deviation, onlyNumbers, className }) => {
  const { t } = useTranslation();
  const { views, isViewCountable } = useDeviationStats(deviation);

  return !isViewCountable ? null : (
    <Stat
      className={className}
      deviation={deviation}
      icon={Eyecon}
      statNameLocaleKey="deviation.stats.views"
      statCount={views}
      onlyNumbers={onlyNumbers}
      title={t('deviation.stats.tooltip.views')}
      biData={BiData<DefaultBiEvent>({
        evid: 2,
        click_info: 'views',
        sectionname: BiContextProvidedValue,
        widgetname: BiContextProvidedValue,
        typeid: BiContextProvidedValue,
        itemid: BiContextProvidedValue,
      })}
    />
  );
};
ViewStat.displayName = 'ViewStat';

export default ViewStat;
